<div class="modal-header">
  <h4 *ngIf="customer && customer.id" class="modal-title" i18n>Edit Location</h4>
  <h4 *ngIf="!customer || !customer.id"class="modal-title" i18n>Add new Location</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <div class="row g-3">
      <div class="col-12">
        <label for="street_address" class="form-label" i18n>Street name and building number</label>
        <app-address-autocomplete *ngIf="!customer || !customer.id" (setAddress)="getAddress($event)"></app-address-autocomplete>
        <input *ngIf="customer && customer.id" type="text" class="form-control" id="office" [readonly]="true" [(ngModel)]="street_address">
      </div>
      <div class="col-12">
        <label for="office" class="form-label" i18n>Apartment or office number</label>
        <input type="text" class="form-control" id="office" [readonly]="customer && customer.id" [(ngModel)]="office">
      </div>
      <div class="col-12">
        <label for="type" class="form-label" i18n>Type</label>
        <select class="form-select" id="type" [(ngModel)]="type" (change)="customer && (customer.type = type)">
          <option *ngFor="let type of customerTypes | keyvalue: onCompare" [disabled]="customer && customer.id" [ngValue]="type.key">{{ type.value }}</option>
        </select>
      </div>
      <div class="col-12" *ngIf="type == 'company'">
        <label class="form-label" i18n>Company name</label>
        <input class="form-control" [(ngModel)]="name" (input)="customer && (customer.name = name)">
      </div>
      <div class="col-12" *ngIf="type == 'institution' || type == 'government'">
        <label class="form-label" i18n>Institution name</label>
        <input class="form-control" [(ngModel)]="name" (input)="customer && (customer.name = name)">
      </div>
      <div class="col-12" *ngIf="type == 'non_profit'">
        <label class="form-label" i18n>Non-profit organization name</label>
        <input class="form-control" [(ngModel)]="name" (input)="customer && (customer.name = name)">
      </div>
      <div class="col-12" *ngIf="type != 'individual'">
        <label class="form-label" i18n>VAT ID (optional)</label>
        <div class="input-group">
          <input class="form-control" [(ngModel)]="vat_id" (input)="checkVatID()">
          <span class="input-group-text">
            <span *ngIf="loadingVat" class="spinner-border spinner-border-sm" role="status" style="color: var(--primary)" aria-hidden="true"></span>
            <span *ngIf="!loadingVat && validVatId" class="text-danger"><fa-icon [icon]="fa.faCheckCircle" style="color: var(--primary)"></fa-icon></span>
            <span *ngIf="!loadingVat && !validVatId" class="text-danger"><fa-icon [icon]="fa.faTimesCircle" style="color: var(--primary)"></fa-icon></span>
          </span>
        </div>
      </div>
    </div>
</div>
<div class="modal-footer">
  <button *ngIf="!customer || !customer.id"type="button" class="btn btn-primary" (click)="save()" i18n>Save</button>
  <button *ngIf="customer && customer.id" type="button" class="btn btn-secondary" (click)="makeDefault()" i18n>Make default</button>
  <button *ngIf="customer && customer.id" type="button" class="btn btn-danger" (click)="delete()" i18n>Delete</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>

